/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Upload_ErrorInputs */

const en_misc_upload_error = /** @type {(inputs: Misc_Upload_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload error`)
};

const es_misc_upload_error = /** @type {(inputs: Misc_Upload_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de subida`)
};

/**
* | output |
* | --- |
* | "Upload error" |
*
* @param {Misc_Upload_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const misc_upload_error = /** @type {((inputs?: Misc_Upload_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Upload_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_misc_upload_error(inputs)
	return en_misc_upload_error(inputs)
});